/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Button, Text } from '@doda/io-react/common';
import styles from './index.module.scss';

type IOButtonProps = React.ComponentProps<typeof Button>;

/**
 * AskCompanyButtonCommonProps
 */
interface AskCompanyButtonCommonProps
  extends Pick<IOButtonProps, 'widthPercentage' | 'size'> {
  /** クリック時の遷移先  */
  href: string;
  /** クリック時に実行する処理  */
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  /** デザインシステム定義サイズを指定 */
  size: 'S' | 'M' | 'L';
}

const AskCompanyButtonUI = (buttonProps: AskCompanyButtonCommonProps) => {
  return (
    <Button as="a" variant="green" {...buttonProps}>
      企業に質問する
    </Button>
  );
};

const AskCompanyHistoryButton = ({
  isApplied,
  ...buttonProps
}: AskCompanyButtonCommonProps & { isApplied: boolean }) => {
  const { size } = buttonProps;
  const isSizeL = size === 'L';
  const annotationText = `${isSizeL ? '※' : ''}${getAnnotationText(isApplied)}`;
  return (
    <Button as="a" variant="outline_blue" {...buttonProps}>
      <span>
        質問履歴をみる
        <Text
          as="span"
          size={isSizeL ? '12' : '10'}
          className={styles['jobSearchDetail-askCompanyButton__subText']}
        >
          {annotationText}
        </Text>
      </span>
    </Button>
  );
};

/**
 * AskCompanyButtonのprops
 */
export interface AskCompanyButtonProps
  /** IOボタンのwidthPercentage,size,onClickを受け取る */
  extends Omit<AskCompanyButtonCommonProps, 'href' | 'widthPercentage'> {
  /** ボタン幅 */
  width?: React.CSSProperties['width'];
  /** 応募済みか */
  isApplied: boolean;
  /** 質問回数制限に到達済みか */
  isReachedLimit: boolean;
  /** 求人ID */
  jid: string;
}

/**
 * 応募状態に応じた注釈テキストを取得する関数
 * @param {boolean} isApplied - 応募が完了しているかどうかの真偽値
 * @returns {string} 応募状態に基づく注釈テキストを返す
 */
const getAnnotationText = (isApplied: boolean) =>
  isApplied ? 'この求人に応募済み' : '質問回数制限に到達済み';

/**
 * AskCompanyButtonコンポーネント。
 * @param args AskCompanyButtonProps
 * 表示判定はこちらのモジュールを使用する packages\common\src\logics\jobSearchDetail\shouldShowDirectMessageButton.ts
 */
export const AskCompanyButton: React.FC<AskCompanyButtonProps> = ({
  isApplied,
  isReachedLimit,
  jid,
  width,
  onClick,
  size,
}) => {
  const href = `/dcfront/message/beforeApplicationMessage/?appid=${jid}`;
  const buttonProps: AskCompanyButtonCommonProps = {
    href,
    onClick,
    size,
    widthPercentage: width ? 100 : undefined,
  };
  return (
    <div style={{ width }}>
      {isReachedLimit || isApplied ? (
        <AskCompanyHistoryButton isApplied={isApplied} {...buttonProps} />
      ) : (
        <AskCompanyButtonUI {...buttonProps} />
      )}
    </div>
  );
};
